const NON_LATIN_LANGUAGE_PREFIXES = new Set([
    'ar', // Arabic
    'bn', // Bengali
    'el', // Greek
    'hi', // Hindi
    'ja', // Japanese
    'kk', // Kazakh (Cyrillic)
    'kn', // Kannada
    'ko', // Korean
    'ml', // Malayalam
    'mr', // Marathi (Devanagari)
    'ru', // Russian (Cyrillic)
    'sr', // Serbian (Cyrillic)
    'ta', // Tamil
    'te', // Telugu
    'uk', // Ukrainian (Cyrillic)
    'zh', // Chinese
]);
export function isNonLatinLocale(locale) {
    const prefix = locale.split('-')[0];
    return NON_LATIN_LANGUAGE_PREFIXES.has(prefix);
}
//# sourceMappingURL=isNonLatinLocale.js.map